<template>
  <v-container class="statisticas">
    <PageTitle
      icon="mdi-home"
      main="Assistência Social"
      sub="AME- Auxílio emergencial"
    />
    <v-card>
      <v-card-title>Posição do cadastro atualizado</v-card-title>
      <div class="stats">
        <estatisticas
          :title="pessoa"
          :value="dados.pcadastro"
          :icon="icoPessoa"
          :cor="corPessoa"
        />
        <estatisticas
          :title="agEnvio"
          :value="dados.agEnvio"
          :icon="icoAgEnvio"
          :cor="corAgEnvio"
        />
        <estatisticas
          :title="agAnalise"
          :value="dados.agAnalise"
          :icon="icoAgAnalise"
          :cor="corAgAnalise"
        />
        <estatisticas
          :title="enAnalise"
          :value="dados.emAnalise"
          :icon="icoEnAnalise"
          :cor="corEnAnalise"
        />
      </div>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import axios from 'axios'
import { baseApiUrl } from '@/global'
import Estatisticas from '../components/Estatisticas.vue'

export default {
  name: 'Statisticas',
  components: { PageTitle, Estatisticas },
  data: () => ({
    dados: {},
    pessoa: 'Pessoas cadastradas',
    agEnvio: 'Aguardando envio',
    agAnalise: 'Aguardando análise',
    enAnalise: 'Em análise',
    deferido: 'Deferido',
    indeferido: 'Indeferido',
    icoPessoa: 'mdi-face',
    icoAgEnvio: 'mdi-file-upload',
    icoAgAnalise: 'mdi-calendar-clock',
    icoEnAnalise: 'mdi-clipboard-text-search',
    icoDeferido: 'mdi-face',
    icoIndeferido: 'mdi-face',
    corPessoa: 'deep-purple accent-4',
    corAgEnvio: 'yellow',
    corAgAnalise: 'orange',
    corEnAnalise: 'green darken-4',
    corDefeirdo: 'teal',
    corIndeferido: 'red'
  }),
  methods: {
    getStats () {
      axios.get(`${baseApiUrl}/statisticas-do-auxilio-emergencial`)
        .then(res => {
          this.dados = res.data
        })
    }
  },
  mounted () {
    this.getStats()
  }
}
</script>

<style>
.stats {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
</style>
